// Ramona & Ruth: durable accordion behavior for product description "Why You'll Love It" / "Details" toggles,
// plus icon/toggle normalization for the native Broadcast "Description" accordion so all three match.
// Lives in its own asset file so it survives theme duplication/updates independent of theme.js.

// All topic icons share the same lighter stroke-width (1.3) to match Emily Ley's thinner
// reference line weight -- previously these varied (1.4-1.6) which read as inconsistent.
var RR_ICON_BOX = '<svg aria-hidden="true" focusable="false" role="presentation" width="18" height="18" viewBox="0 0 22 22"><g stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" fill="none"><path d="M2 16.11V5.89a.6.6 0 0 1 .356-.548l8.4-3.734a.6.6 0 0 1 .488 0l8.4 3.734A.6.6 0 0 1 20 5.89v10.22a.6.6 0 0 1-.356.548l-8.4 3.734a.6.6 0 0 1-.488 0l-8.4-3.734A.6.6 0 0 1 2 16.11Z"/><path d="M2.405 5.658C8.031 8.193 10.896 9.438 11 9.392 5.126 6.838 2.26 5.594 2.405 5.658ZM11 20.444c.104-7.321.104-11.005 0-11.05.144 7.302.144 10.986 0 11.05ZM19.848 5.658C14.053 8.194 11.104 9.439 11 9.393c6.043-2.554 8.992-3.8 8.848-3.735Z"/><path d="m6.5 3.5 8.644 3.842a.6.6 0 0 1 .356.548v3.61"/></g></svg>';

var RR_ICON_HEART = '<svg aria-hidden="true" focusable="false" role="presentation" width="18" height="18" viewBox="0 0 24 24"><path d="M22 8.862a5.95 5.95 0 0 1-1.654 4.13c-2.441 2.531-4.809 5.17-7.34 7.608-.581.55-1.502.53-2.057-.045l-7.295-7.562c-2.205-2.286-2.205-5.976 0-8.261a5.58 5.58 0 0 1 8.08 0l.266.274.265-.274A5.612 5.612 0 0 1 16.305 3c1.52 0 2.973.624 4.04 1.732A5.95 5.95 0 0 1 22 8.862z" fill="none" stroke-width="1.3" stroke="currentColor" stroke-linejoin="round"/></svg>';

var RR_ICON_NOTES = '<svg aria-hidden="true" focusable="false" role="presentation" width="18" height="18" viewBox="0 0 24 24"><path d="M8 14h8m-8-4h2m-2 8h4M10 3H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-3.5M10 3V1m0 2v2" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

var RR_ICON_RULER = '<svg aria-hidden="true" focusable="false" role="presentation" width="18" height="18" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></g></svg>';

function rrIconForLabel(text) {
  var t = text.toLowerCase();
  if (t.indexOf('shipping') !== -1 || t.indexOf('return') !== -1) return RR_ICON_BOX;
  if (t.indexOf('detail') !== -1) return RR_ICON_RULER;
  if (t.indexOf('love it') !== -1 || t.indexOf("why you") !== -1) return RR_ICON_HEART;
  if (t.indexOf('description') !== -1) return RR_ICON_NOTES;
  return null;
}

// Ramona & Ruth product descriptions have "Why You'll Love It" / "Details" accordions
// hand-coded *inside* the same product description field as the intro copy. Broadcast's
// native "Description" accordion block pulls that whole field verbatim, which leaves those
// two accordions nested inside the Description accordion (they'd vanish if Description were
// closed). This pulls them back out to be independent top-level accordions, matching the
// Emily Ley reference layout, without requiring any change to the product description content.
//
// IMPORTANT: pair buttons with panels by DOCUMENT ORDER, not by btn.nextElementSibling.
// A lot of older product descriptions were pasted from Google Docs and wrap the button in a
// stray <p> (e.g. "<p><button class='accordion_product'>Details</button></p><div class='panel_product'>...").
// When that happens btn.nextElementSibling is null (nothing else inside that <p>), so the old
// sibling-based pairing left the panel behind, orphaned inside the closed Description content --
// the button would unnest into its own row but clicking it did nothing, because there was no
// panel next to it to toggle. Pairing by document order works regardless of wrapper tags.
function rrUnnestAccordions() {
  document.querySelectorAll('details.accordion').forEach(function (detailsEl) {
    var buttons = Array.prototype.slice.call(detailsEl.querySelectorAll('.accordion_product'));
    var panels = Array.prototype.slice.call(detailsEl.querySelectorAll('.panel_product'));
    if (!buttons.length) return;

    var insertionPoint = detailsEl;
    buttons.forEach(function (btn, i) {
      var panel = panels[i];
      insertionPoint.insertAdjacentElement('afterend', btn);
      insertionPoint = btn;
      if (panel) {
        insertionPoint.insertAdjacentElement('afterend', panel);
        insertionPoint = panel;
      }
    });

    // Clean up now-empty wrapper elements left behind inside the Description content
    // (e.g. an emptied-out <p> that used to wrap a button we just moved out).
    detailsEl.querySelectorAll('p, div').forEach(function (el) {
      if (el.textContent.trim() === '' && el.children.length === 0) {
        el.remove();
      }
    });
  });
}

// After pulling "Why You'll Love It"/"Details" out of the description content, empty
// leftover spacer elements (blank <br>, empty <div class="column">, etc. that originally
// separated the intro copy from those accordions) are left behind and create a large gap.
// Recursively strip any trailing elements that have no text and no meaningful media content.
function rrTrimTrailingEmpty(container) {
  if (!container) return;
  var changed = true;
  while (changed) {
    changed = false;
    var last = container.lastElementChild;
    if (!last) break;
    var isEmpty = last.textContent.trim() === '' && !last.querySelector('img, svg, video, iframe, table');
    if (isEmpty) {
      last.remove();
      changed = true;
    } else if (last.lastElementChild) {
      var beforeCount = last.children.length;
      rrTrimTrailingEmpty(last);
      if (last.children.length !== beforeCount) changed = true;
    }
  }
}

function rrCleanupDescriptionContent() {
  document.querySelectorAll('.accordion__content').forEach(function (content) {
    rrTrimTrailingEmpty(content);
  });
}

function rrInitAccordionIcons() {
  document.querySelectorAll('.accordion_product').forEach(function (btn) {
    if (btn.hasAttribute('data-rr-init')) return;
    btn.setAttribute('data-rr-init', 'true');

    var label = btn.textContent.trim();
    var svg = rrIconForLabel(label);

    var toggleIcon = document.createElement('span');
    toggleIcon.className = 'rr-accordion-icon';
    toggleIcon.textContent = '+';

    if (svg) {
      var topicIcon = document.createElement('span');
      topicIcon.className = 'rr-accordion-topic-icon';
      topicIcon.innerHTML = svg;
      btn.appendChild(topicIcon);
    }

    btn.appendChild(toggleIcon);

    btn.setAttribute('aria-expanded', 'false');
  });
}

// Normalize the native Broadcast "Description" accordion (a <details>/<summary class="accordion__title">
// pair) to use the exact same icon + "+"/"−" toggle treatment as the hand-coded accordions above,
// instead of Broadcast's own icon__animated chevron, so all three accordions look identical.
function rrNormalizeNativeAccordions() {
  document.querySelectorAll('summary.accordion__title').forEach(function (summary) {
    if (summary.hasAttribute('data-rr-init')) return;
    summary.setAttribute('data-rr-init', 'true');

    var label = summary.textContent.trim();
    var svg = rrIconForLabel(label);

    Array.prototype.slice.call(summary.children).forEach(function (child) {
      child.remove();
    });

    if (svg) {
      var topicIcon = document.createElement('span');
      topicIcon.className = 'rr-accordion-topic-icon';
      topicIcon.innerHTML = svg;
      summary.appendChild(topicIcon);
    }

    var toggleIcon = document.createElement('span');
    toggleIcon.className = 'rr-accordion-icon';
    var detailsEl = summary.closest('details');
    toggleIcon.textContent = detailsEl && detailsEl.open ? '−' : '+';
    summary.appendChild(toggleIcon);

    if (detailsEl) {
      detailsEl.addEventListener('toggle', function () {
        toggleIcon.textContent = detailsEl.open ? '−' : '+';
      });
    }
  });
}

// Judge.me's "Customer Love" testimonials carousel bundles the star rating and the reviewer's
// name together in one .jdgm-rating-section block, with no setting to separate them. Kim wants
// stars at the top of the card and the reviewer name underneath the quote (not next to the stars).
// This physically moves just the .jdgm-reviewer-info piece (name + verified badge) out of
// .jdgm-rating-section to sit right after .jdgm-text, leaving the stars alone at the top.
// Guarded by a data attribute so it's safe to re-run if Judge.me re-renders/clones carousel slides.
function rrRepositionReviewerNames() {
  document.querySelectorAll('.jdgm-testimonial').forEach(function (card) {
    var reviewerInfo = card.querySelector('.jdgm-rating-section .jdgm-reviewer-info');
    var text = card.querySelector('.jdgm-text');
    if (reviewerInfo && text && !reviewerInfo.hasAttribute('data-rr-moved')) {
      reviewerInfo.setAttribute('data-rr-moved', 'true');
      text.insertAdjacentElement('afterend', reviewerInfo);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  rrUnnestAccordions();
  rrCleanupDescriptionContent();
  rrInitAccordionIcons();
  rrNormalizeNativeAccordions();
  rrRepositionReviewerNames();

  var jdgmContainer = document.querySelector('.jdgm-testimonials-container');
  if (jdgmContainer && window.MutationObserver) {
    var jdgmObserver = new MutationObserver(function () {
      rrRepositionReviewerNames();
    });
    jdgmObserver.observe(jdgmContainer, { childList: true, subtree: true });
  }
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.accordion_product');
  if (!btn) return;
  var panel = btn.nextElementSibling;
  if (!panel || !panel.classList.contains('panel_product')) return;
  var isOpen = btn.classList.contains('active');
  btn.classList.toggle('active', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
  var icon = btn.querySelector('.rr-accordion-icon');
  if (icon) icon.textContent = isOpen ? '+' : '−';
});
